module.exports = __webpack_public_path__ + "static/media/IMG_9036.075e47db.JPG";